<template>
  <div>
    <b-card no-body>
      <div class="m-2">
        <b-row class="pb-1">
          <b-col cols="12">
            <h4>Danh sách loại thông báo</h4>
          </b-col>
        </b-row>
        <b-row class="pb-1">
          <b-col class="text-left" cols="5">
            <b-button class="btn-sm mr-50" variant="primary" @click="New()">
              <feather-icon class="align-text-top" icon="PlusIcon" size="16"/>
              Thêm mới
            </b-button>
            <b-button class="btn-sm" variant="primary" @click="DeleteList()">
              <feather-icon class="align-text-top" icon="DeleteIcon" size="16"/>
              Xóa
            </b-button>
          </b-col>
          <b-col cols="6">
            <b-input-group>
              <b-form-input v-model="searchQuery" placeholder="Tìm kiếm " v-on:keydown.enter="quickSearch"/>
              <b-input-group-append is-text role="button" @click="quickSearch">
                <feather-icon icon="SearchIcon"/>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <vue-good-table :columns="options.fields" :isLoading.sync="isLoading" :line-numbers="true" :rows="items"
                            :select-options="{ enabled: true }" :totalRows="totalRecords"
                            mode="remote"
                            @on-page-change="onPageChange" @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange" @on-selected-rows-change="selectionChanged">
              <template slot="table-row" slot-scope="props">
                <!-- Column: Action -->
                <span v-if="props.column.field === 'action'">
                    <span>
                      <b-button class="btn-icon" size="sm" variant="primary" @click="Edit(props.row, props.row.id)">
                        <feather-icon icon="Edit2Icon"/>
                      </b-button>
                      <b-button class="btn-icon" size="sm" style="margin-left: 6px" variant="danger"
                                @click="DeleteItem(props.row, props.row.id)">
                        <feather-icon icon="TrashIcon"/>
                      </b-button>
                    </span>
                  </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-modal id="modal-edit" :title="getTitle()" size="lg" @ok="handleOk">
      <form ref="form">
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label>Tên loại thông báo <span class='text-danger'>*</span></label>
              <b-form-input v-model="currentItem.name" :state="validateState('name')" placeholder="Tên loại thông báo"
                            required/>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Mô tả loại thông báo">
              <b-form-textarea v-model="currentItem.description" k-max-length="500" max-rows="20"
                               placeholder="Mô tả loại thông báo" rows="8"/>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group>
              <label>Thứ tự</label>
              <b-form-input v-model="currentItem.sort_order" max="9999999" min="0" type="number"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </form>
    </b-modal>
  </div>
</template>
<script>

import {ValidationProvider, ValidationObserver} from "vee-validate";
import {required} from "@validations";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import {
  BFormDatepicker,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BModal,
  BFormCheckbox,
  BFormGroup,
  VBTooltip,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import moment from "moment";
import {stringToDate} from "@/@core/utils/utils";
import {getuserName} from '@/@core/utils/utils';


export default {
  name: "adminTopic",
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BFormTextarea,
    BInputGroup, BInputGroupAppend
  },
  methods: {
    validateState(pro) {
      if (!this.isSubmit) return null;
      if (!this.currentItem[pro]) return false;
      else return true;
      return null;
    },
    validateStateSub(pro) {
      if (!this.isSubmit) return null;
      if (!this.currentItemSub[pro]) return false;
      else return true;
      return null;
    },
    getTitle() {
      if (this.editMode) {
        return "Cập nhật loại thông báo ";
      } else {
        return "Thêm mới loại thông báo ";
      }
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.loadItems();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.serverParams.page = 1;
      this.updateParams(params);
      console.log(this.serverParams);
      this.loadItems();
    },

    New() {
      this.currentItem = {};
      this.editMode = false;
      this.modal_title = "Thêm mới loại thông báo ";
      this.$bvModal.show("modal-edit");
    },

    async Edit(item) {
      this.currentItem = item;
      this.editMode = true;
      this.modal_title = "Cập nhật loại thông báo";
      this.$bvModal.show("modal-edit");
    },

    async DeleteItem(item, index, button) {
      this.currentItem = item;
      const url = `portal/typeNotice/${item.id}`;
      let resModal = await this.$bvModal.msgBoxConfirm(
          "Vui lòng xác nhận bạn muốn xoá liệu loại thông báo",
          {title: "Please Confirm", size: "sm"}
      );
      if (resModal) {
        try {
          this.loading(true);
          let res = await useJwt.delete(url);
          this.loading(false);
          if (res.data.code == 200) {
            this.loadItems();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Xoá loại thông báo thành công!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          }
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi xoá loại thông báo ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      }
    },
    selectionChanged(params) {
      this.rowSelection = params.selectedRows;
    },
    async DeleteList() {
      if (this.rowSelection.length == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải chọn dữ liệu cần xóa. Xin vui lòng kiểm tra lại!",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return;
      }
      let resModal = await this.$bvModal.msgBoxConfirm(
          "Vui lòng xác nhận bạn muốn xoá loại thông báo",
          {title: "Please Confirm", size: "sm"}
      );

      if (resModal) {
        const listId = [];
        for (var i = 0; i < this.rowSelection.length; i++) {
          listId.push(this.rowSelection[i].id);
        }
        const createParams = {
          ids: listId.join(',')
        };
        try {
          this.loading(true);
          const res = await useJwt.post("portal/deleteTypeNotice", createParams);
          this.loading(false);
          if (res.data.code == 200) {
            this.isSubmit = false;
            this.loadItems();
            return this.$toast({
              component: ToastificationContent,
              props: {
                title: "Xóa loại thông báo thành công!",
                icon: "CheckSquareIcon",
                variant: "success",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: res.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi xóa loại thông báo ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      }
    },

    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      const userName = getuserName();
      this.isSubmit = true;

      const bIsValid = await this.isValid(this.currentItem);
      if (!bIsValid) {
        return;
      }

      if (this.editMode) {
        const url = `portal/typeNotice/${this.currentItem.id}`;

        const updateParams = {
          id: this.currentItem.id,
          name: this.currentItem.name,
          parent_id: null,
          sort_order: this.currentItem.sort_order,
          description: this.currentItem.description,
          created_at: userName,
          updated_at: userName
        };
        try {
          this.loading(true);
          const res = await useJwt.put(url, updateParams);
          this.loading(false);
          if (res.data.code == 200) {
            this.isSubmit = false;
            this.loadItems();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Cập nhật thành công!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
            this.$bvModal.hide("modal-edit");
            return;
          }
        } catch (error) {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lỗi cập nhật loại thông báo ",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return
        }
      }
      try {
        const createParams = {
          id: 0,
          name: this.currentItem.name,
          sort_order: this.currentItem.sort_order,
          description: this.currentItem.description,
          updated_at: userName,
          created_at: userName
        };
        this.loading(true);
        const res = await useJwt.post("portal/typeNotice", createParams);
        this.loading(false);
        if (res.data.code == 200) {
          this.isSubmit = false;
          this.loadItems();
          this.$bvModal.hide("modal-edit");
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "Thêm mới loại thông báo thành công!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        }
      } catch (error) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi thêm mới loại thông báo ",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },

    async isValid(item) {
      if (!item.name) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Tên không được để trống",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return false;
      }

      return true;
    },

    async loadItems() {
      try {
        this.loading(true);
        useJwt.get("portal/typeNotice?filter=" + this.searchQuery).then((response) => {
          var result = response.data;
          if (result.code == 200) {
            this.items = result.result;
            this.totalRecords = result.totalRecords;
          }

          this.isLoading = false;
          this.loading(false);
        });
      } catch {
        this.loading(false);
      }
    },

    async quickSearch() {
      this.loadItems();
    },

    dateFormat(v) {
      return moment(v, 'YYYYMMDDHHmmss').format('DD/MM/YYYY hh:mm:ss')
    }
  },

  mounted() {
    this.loadItems();
    this.isSubmit = false;
  },

  data() {
    return {
      isLoading: false,
      isSubmit: false,
      totalRecords: 0,
      items: [],
      statusList: [
        {id: 1, text: "Hiệu lực"},
        {id: 0, text: "Hết hiệu lực"}
      ],
      editMode: false,
      totalItem: 0,
      searchQuery: "",
      currentItem: {},
      rowSelection: [],
      options: {
        fields: [
          {field: "action", label: "Cài đặt", width: "120px"},
          {
            field: "name",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Tên loại thông báo",
            required: true,
            disabled: true,
            sort: false
          },
          {
            field: "description",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Mô tả",
            required: true,
            sort: false,
            disabled: true,
          },
          {
            field: "created_date",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Ngày tạo",
            type: 'date',
            dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss',
            dateOutputFormat: 'dd/MM/yyyy HH:mm:ss',
            disabled: true,
            sort: false
          }
        ]
      },
    };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
.readonly {
  pointer-events: none;
  touch-action: none;

  .select2-selection {
    background: #eee;
    box-shadow: none;
  }

  .select2-selection__arrow,
  .select2-selection__clear {
    display: none;
  }
}

table.vgt-table td {
  min-width: 100px;
}
</style>
